import * as React from "react"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import { Link, useTranslation } from "@zestia/gatsby-plugin-react-i18next"
import findImage from "@/utils/find-image"
import { useStaticQuery, graphql } from "gatsby"
import { gtmTracking } from "@/utils/gtm-tracking"

const PrimaryHeader = ({
  className = "",
  buttonClassName = "",
  backgroundClass,
  kickerText,
  kickerClass = "heading-kicker",
  title,
  description,
  g2Badges = false,
  secondaryButton,
  imageBackdrop = true,
  primaryHeaderBackdropNew = false,
  image,
  imageClassName = "",
  children,
  signupButtonHref = "/signup/",
  signupButtonOnClick,
}) => {
  const { t } = useTranslation()
  const data = useStaticQuery(graphql`
    query {
      allFile(
        filter: {
          sourceInstanceName: { eq: "images" }
          relativeDirectory: { eq: "social-proof" }
        }
      ) {
        edges {
          node {
            childImageSharp {
              gatsbyImageData(placeholder: BLURRED, quality: 70)
            }
          }
        }
      }
    }
  `)

  return (
    <section className={`primary-header ${className}`}>
      <div className="container-fluid row middle-sm between-md">
        {primaryHeaderBackdropNew ? (
          <div className="col-xs-12 col-md-5 mt-10 sm:mt-0 mb-10 sm:mb-0 sm:pt-10 sm:pb-10 primary-header__content">
            {kickerText && (
              <span className={`${kickerClass} pt-10 md:pt-0`}>
                {kickerText}
              </span>
            )}
            <h1 className="mt-3">{title}</h1>
            {children && children}
            {description && <p className="p--lg">{description}</p>}

            <div className="primary-header__buttons">
              <Link
                to={signupButtonHref}
                className={`btn ${buttonClassName || "btn--dark"}`}
                onClick={e => {
                  gtmTracking("CTA Click", "Try Free", "Hero")()

                  if (signupButtonOnClick) {
                    e.preventDefault()
                    signupButtonOnClick(e)
                  }
                }}
              >
                {t("common.try-free")}
              </Link>

              {secondaryButton}
              {g2Badges && (
                <GatsbyImage
                  image={getImage(findImage(data.allFile, "g2-three-badges"))}
                  alt="G2 badges"
                  className="primary-header__g2-badges"
                />
              )}
            </div>
          </div>
        ) : (
          <div className="col-xs-12 col-sm-6 col-md-6 mt-10 sm:mt-0 mb-10 sm:mb-0 sm:pt-10 sm:pb-10 primary-header__content">
            {kickerText && (
              <span className={`${kickerClass} pt-10 md:pt-0`}>
                {kickerText}
              </span>
            )}
            <h1>{title}</h1>
            {children && children}
            {description && <p className="p--lg">{description}</p>}

            <div className="primary-header__buttons">
              <Link
                to={signupButtonHref}
                className={`btn ${buttonClassName || "btn--dark"}`}
                onClick={e => {
                  gtmTracking("CTA Click", "Try Free", "Hero")()

                  if (signupButtonOnClick) {
                    e.preventDefault()
                    signupButtonOnClick(e)
                  }
                }}
              >
                {t("common.try-free")}
              </Link>
              {secondaryButton}
            </div>
          </div>
        )}

        {primaryHeaderBackdropNew ? (
          <div className="col-xs-12 col-md-5 primary-header__asset">
            <div
              className={imageBackdrop ? "primary-header__backdrop--new" : ""}
            >
              <GatsbyImage
                image={getImage(image.src)}
                alt={image.alt}
                imgClassName={imageClassName}
              />
            </div>
          </div>
        ) : (
          <div
            className={`col-xs-12 col-sm-6 col-md-5 primary-header__asset${
              !imageBackdrop ? " primary-header__asset--no-animation" : ""
            }`}
          >
            <div className="pt-10 sm:pt-16 pb-10 sm:pb-16 pr-10 vs:pr-16 sm:pr-0">
              {imageBackdrop && (
                <div
                  className={`primary-header__backdrop ${backgroundClass || ""}`}
                ></div>
              )}
              <GatsbyImage
                image={getImage(image.src)}
                alt={image.alt}
                imgClassName={imageClassName || "primary-header__image"}
              />
            </div>
          </div>
        )}
      </div>
    </section>
  )
}

export default PrimaryHeader
